import { render, staticRenderFns } from "./controls.vue?vue&type=template&id=25547b9e&lang=pug&"
import script from "./controls.vue?vue&type=script&lang=js&"
export * from "./controls.vue?vue&type=script&lang=js&"
import style0 from "./controls.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports